import React, { Suspense } from 'react';
import { useLocation } from '../../../../helpers/routing';
import { getUrlSlug, isChatbotUrl, isT404PUrl } from '../../../../helpers/url';
import { LocationState, SurveyContainerLocationState } from '../../../survey-container/types';

const ChatbotTheme = React.lazy(() => import('./ChatbotTheme'));
const VirtualCareTheme = React.lazy(() => import('./VirtualCareTheme'));
const ClassicTheme = React.lazy(() => import('./ClassicTheme'));

const PageNodeThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation() as LocationState;
  const { mghUrl }: SurveyContainerLocationState = location.state || {};
  const urlSlug = getUrlSlug(mghUrl, location).toLowerCase();

  if (isChatbotUrl(urlSlug)) {
    return (
      <Suspense fallback={null}>
        <ChatbotTheme>{children}</ChatbotTheme>
      </Suspense>
    );
  } else if (isT404PUrl(urlSlug)) {
    return (
      <Suspense fallback={null}>
        <VirtualCareTheme>{children}</VirtualCareTheme>
      </Suspense>
    );
  }
  return (
    <Suspense fallback={null}>
      <ClassicTheme>{children}</ClassicTheme>
    </Suspense>
  );
};

export default PageNodeThemeProvider;
